module.exports = __webpack_public_path__ + "img/换货.53324e4a.svg";